import CalendarIcon from './Calendar';

export default CalendarIcon;
